/* eslint-disable import/prefer-default-export */
const anchorTags = {
  LP_BANNER: 'referral',
  LP_NUTRIZONES: 'lp-nutrizones-section',
};

export { anchorTags };
